const breakAfter ={
    name: "break-after",
    path: "/break-after",
    title: "break-after",
    description: "Utilities for controlling how a column or page should break after an element.",
    value: {
        "break-after":{
            "break-after-auto": "auto",
        "break-after-avoid": "avoid",
        "break-after-all": "all",
        "break-after-avoid-page": "avoid-page",
        "break-after-page": "page",
        "break-after-column": "column",
        }
    },
    exampleData: [
        {
            "title": "break-after-column, break-after-page",
            "description": "utilities like to control how a column or page break should behave after an element:",
            "moreDescription": "",
            "parentClass": "",
            "example": {
                "element": "",
                "src": [],
                "className": "",
                "code": `<div class="columns-2">
    <p>Well, let me tell you something, ...</p>
    <p class="break-after-column">Sure, go ahead, laugh...</p>
    <p>Maybe we can live without...</p>
    <p>Look. If you think this is...</p>
</div>`
            }
        },
        {
            "title": "break-after",
            "description": "utility with a breakpoint variant like md: to only apply the utility at medium screen sizes and above:",
            "moreDescription": "",
            "parentClass": "",
            "example": {
                "element": "",
                "src": "",
                "className": "",
                "code": `<div class="break-after-column md:break-after-auto ...">
    <!-- ... -->
</div>`
            }
        }
    ]
}
export default breakAfter;